import type { MoriartyEnvironment, MoriartyEnvironmentStatus } from "./types";

// Keep the lifecycle resuming so a successful retry can still report ready and
// drain its preserved queue. A reported failure is not an in-progress wake.
export function getMoriartyDisplayStatus(
  environment: Pick<MoriartyEnvironment, "status" | "errorMessage">,
): MoriartyEnvironmentStatus | "resume_failed" {
  return environment.status === "resuming" && environment.errorMessage
    ? "resume_failed"
    : environment.status;
}

const STATUS_PRIORITY: Record<MoriartyEnvironmentStatus, number> = {
  starting: 0,
  resuming: 1,
  ready: 2,
  warning: 3,
  stopping: 4,
  stopped: 5,
  boot_failed: 6,
  failed: 7,
  terminated: 8,
};

export function compareMoriartyStatuses(
  a: MoriartyEnvironmentStatus,
  b: MoriartyEnvironmentStatus,
): number {
  return STATUS_PRIORITY[a] - STATUS_PRIORITY[b];
}

export function isMoriartyProntoEligible(
  environment: Pick<MoriartyEnvironment, "status" | "prNumber">,
): boolean {
  return (
    (environment.status === "ready" || environment.status === "warning") &&
    environment.prNumber !== null
  );
}
